var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"properties-popup"},[_c('div',{staticClass:"properties-list"},[_c('draggable',{attrs:{"list":_vm.localColumns},on:{"change":_vm.changeColumnOrder}},_vm._l((_vm.localColumns),function(column){return _c('PropertyItem',{key:column.field,attrs:{"column":column}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }